import React, { useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import HoverInfo from "./HoverInfo/HoverInfo";
const HoverInfoStyle = styled.div`
  position: relative;
  ${props => props.isHover || css`
      display: none;
    `}
`;

const InfoCircle = ({
  className,
  hoverInfoDescriptions
}) => {
  const [isHover, setIsHover] = useState(false);
  return /*#__PURE__*/React.createElement("span", {
    className: className,
    onMouseOver: () => setIsHover(true),
    onMouseOut: () => setIsHover(false)
  }, /*#__PURE__*/React.createElement(HoverInfoStyle, {
    isHover: isHover
  }, /*#__PURE__*/React.createElement(HoverInfo, {
    hoverInfoDescriptions: hoverInfoDescriptions
  })), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faInfoCircle
  }));
};

InfoCircle.propTypes = {
  className: PropTypes.string,
  hoverInfoDescriptions: PropTypes.string
};
export default styled(InfoCircle)`
  font-size: 14px;
  float: right;
`;